import { ActionTree } from 'vuex';
import { FETCH_DEVICE_STATUS, FETCH_DEVICE_COUNT, MetricsState, IDeviceStatusItem, IDeviceCount } from './types';
// TODO
// import { FETCH_DEVICE_STATUS, UPDATE_DEVICE_STATUS_STATE, SET_ERROR, MetricsState } from './types';
// import { MetricsApiCaller as MetricsApi } from './caller';
// MetricsApi.getDeviceStatus
// commit SET_ERROR, update state...etc.

const actions: ActionTree<MetricsState, Record<string, never>> = {
  async [FETCH_DEVICE_STATUS](): Promise<IDeviceStatusItem[]> {
    return Promise.resolve([
      {
        status: 'active', count: 200
      },
      {
        status: 'warning', count: 40
      },
      {
        status: 'locked', count: 50
      },
      {
        status: 'failure', count: 10
      },
      {
        status: 'inactive', count: 25
      }
    ]);
  },
  async [FETCH_DEVICE_COUNT](): Promise<IDeviceCount> {
    return Promise.resolve({
      startDate: '2022-04-27T00:00:00Z',
      endDate: '2022-04-28T00:00:00Z',
      buckets: [
        {
          label: '00:00', value: 42
        },
        {
          label: '01:00', value: 20
        },
        {
          label: '02:00', value: 58
        },
        {
          label: '03:00', value: 13
        },
        {
          label: '04:00', value: 16
        },
        {
          label: '05:00', value: 28
        },
        {
          label: '06:00', value: 33
        },
        {
          label: '07:00', value: 25
        },
        {
          label: '08:00', value: 51
        },
        {
          label: '09:00', value: 12
        },
        {
          label: '10:00', value: 19
        },
        {
          label: '11:00', value: 20
        },
        {
          label: '12:00', value: 41
        },
        {
          label: '13:00', value: 42
        },
        {
          label: '14:00', value: 20
        },
        {
          label: '15:00', value: 13
        },
        {
          label: '16:00', value: 30
        },
        {
          label: '17:00', value: 35
        },
        {
          label: '18:00', value: 51
        },
        {
          label: '19:00', value: 49
        },
        {
          label: '20:00', value: 41
        },
        {
          label: '21:00', value: 8
        },
        {
          label: '22:00', value: 17
        },
        {
          label: '23:00', value: 31
        }
      ]
    });
  }
};
export default actions;
